import { render, staticRenderFns } from "./MiningLandscape.vue?vue&type=template&id=de8a03b8"
import script from "./MiningLandscape.vue?vue&type=script&lang=js"
export * from "./MiningLandscape.vue?vue&type=script&lang=js"
import style0 from "./MiningLandscape.vue?vue&type=style&index=0&id=de8a03b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports